import { FC } from 'react'

// hooks
import { useAppSelector, useAppDispatch } from '@/hooks'
// features
import {
  reportSelectReportCommentModalOpen,
  reportCloseReportCommentModal,
} from '@/features'
// components
import { ModalLayout } from '@/components'

// components
import { ReportCommentCard } from './components'
// styles
import { styles } from './styles'

type ReportCommentModalProps = {}

export const ReportCommentModal: FC<ReportCommentModalProps> = () => {
  const dispatch = useAppDispatch()
  const reportCommentModalOpen = useAppSelector(reportSelectReportCommentModalOpen)

  return (
    <div css={styles().modal.main}>
      {reportCommentModalOpen && (
        <ModalLayout
          background="opaque"
          onOutsideClick={() => dispatch(reportCloseReportCommentModal())}
        >
          <div css={styles().modal.content}>
            <ReportCommentCard />
          </div>
        </ModalLayout>
      )}
    </div>
  )
}

ReportCommentModal.propTypes = {}
